import React, { useState } from 'react';
import { Card, CardHeader, CardContent } from "./components/ui/card";

const PricingPackages = () => {
  const [openAccordions, setOpenAccordions] = useState({});

  const packages = [
    {
      name: 'Free Module',
      description: 'Essential travel management features included at no cost',
      sections: [
        {
          title: 'Platform',
          items: [
            'Onboarding',
            'Access to app',
            'Access to choice of OBT',
            'Profile management',
            'Traveller mgmt for arrangers',
            'Travel manager permissions',
            'Itinerary mgmt',
            'Safety & risk basic dashboard',
            'My company page personalisation',
            'Announcements',
            'Send message in app',
            'View and download invoices',
            'Export traveller data'
          ]
        },
        {
          title: 'FCM Extension',
          items: [
            'Concur or Cytric as supported OBT',
            'Non-Customizable Notifications (pre-set)',
            'Leakage redirection',
            'CIBT Visa Guidance',
            'Sherpa Travel Guidance',
            '1 Route-based Notification',
            'Unused Credit Notifications',
            'Access via SSO',
            'Support only during initial setup'
          ]
        },
        {
          title: 'Reporting',
          items: [
            'Financial Invoice',
            'Audit Dashboards',
            'Benchmark Dashboards',
            'Financial Seg OD Dashboards',
            'Reservation Dashboards',
            'Traveller Wellness Dashboards',
            'Trends & KPIs'
          ]
        },
        {
          title: 'Online Booking Tool (OBT)',
          items: [
            'Choice of OBT'
          ]
        }
      ],
      pricing: {
        small: 'Free',
        medium: 'Free',
        large: 'Free'
      }
    },
    {
      name: 'FCM Approvals',
      description: 'Comprehensive travel approval management system',
      sections: [
        {
          title: 'Features',
          items: [
            'Active approval flow',
            'Passive approval flow',
            'Site redirect',
            'Custom notifications'
          ]
        }
      ],
      pricing: {
        small: '$0.50',
        medium: '$0.35',
        large: '$0.25'
      }
    },
    {
      name: 'Authorisations',
      description: 'Pre-booking travel authorisation system',
      sections: [
        {
          title: 'Features',
          items: [
            'Pre-booking travel authorisation',
            'Customizable approval workflows',
            'Integration with booking tools'
          ]
        }
      ],
      pricing: {
        small: '$0.50',
        medium: '$0.35',
        large: '$0.25'
      }
    },
    {
      name: 'The Decision Assist (FCMX)',
      description: 'Advanced travel decision assistance and customization platform',
      sections: [
        {
          title: 'Features',
          items: [
            'Unlimited notifications',
            'Full customization of notifications',
            'Ability to create new notifications',
            'Concur, Cytric, Savi, Deem, and FCMBooking supported',
            'Sustainability guidance (powered by Thrust Carbon)',
            'Access via SSO or Login-less',
            'Ongoing technical support',
            'Quarterly reporting',
            'Leakage Report'
          ]
        }
      ],
      pricing: {
        small: '$0.50',
        medium: '$0.40',
        large: '$0.35'
      }
    },
    {
      name: 'Advanced Reporting (w/o Expense Connector)',
      description: 'Enhanced analytics and reporting capabilities powered by AI',
      sections: [
        {
          title: 'What if Analysis & Travel Manager Tools',
          items: [
            'Hotel Policy Simulation',
            'Class of Service Simulation',
            'Online Fee Savings Opportunity',
            'Advanced Booking Savings Opportunity',
            'Air Behavioral Dashboard'
          ]
        },
        {
          title: 'AI Reporting',
          items: [
            'Natural language queries'
          ]
        },
        {
          title: 'Flight Status',
          items: [
            'Flight Disruption Risk',
            'Risk and Delay Monitoring and Reporting'
          ]
        },
        {
          title: 'Roadmap',
          items: [
            'NextGen AI (chaptgpt analytics engine)',
            'lowest logical carbon emissions automation',
            'co2 leakage report'
          ]
        }
      ],
      pricing: {
        small: '$0.55',
        medium: '$0.45',
        large: '$0.35'
      }
    },
    {
      name: 'Advanced Reporting (w/ Expense Connector)',
      description: 'Enhanced analytics and reporting capabilities powered by AI',
      sections: [
        {
          title: 'Expense Connector Tech Integration',
          items: [],
        },
        {
          title: 'What if Analysis & Travel Manager Tools',
          items: [
            'Hotel Policy Simulation',
            'Class of Service Simulation',
            'Online Fee Savings Opportunity',
            'Advanced Booking Savings Opportunity',
            'Air Behavioral Dashboard'
          ]
        },
        {
          title: 'AI Reporting',
          items: [
            'Natural language queries'
          ]
        },
        {
          title: 'Flight Status',
          items: [
            'Flight Disruption Risk',
            'Risk and Delay Monitoring and Reporting'
          ]
        },
        {
          title: 'Roadmap',
          items: [
            'NextGen AI (chaptgpt analytics engine)',
            'lowest logical carbon emissions automation',
            'co2 leakage report'
          ]
        }
      ],
      pricing: {
        small: '$0.55',
        medium: '$0.45',
        large: '$0.35'
      }
    },
    {
      name: 'Enhanced Data Handoff Module',
      description: 'Advanced data integration and transfer services',
      sections: [
        {
          title: 'Features',
          items: [
            'Automated data transfer',
            'Custom data formats',
            'Real-time synchronization'
          ]
        }
      ],
      pricing: {
        small: '$0.20',
        medium: '$0.18',
        large: '$0.15'
      }
    }
  ];

  const toggleAccordion = (packageName) => {
    setOpenAccordions(prev => ({
      ...prev,
      [packageName]: !prev[packageName]
    }));
  };

  return (
    <div className="max-w-7xl mx-auto p-4">
      <h1 className="text-3xl font-bold mb-4 text-center">Pricing Packages</h1>
      
      <div className="bg-blue-50 p-6 rounded-lg mb-8">
        <h2 className="text-xl font-bold mb-3">Save More with Multi-Package Discounts!</h2>
        <p className="mb-3">Take advantage of our progressive discount structure when you combine multiple packages:</p>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4">
          <div className="bg-white p-4 rounded-lg shadow">
            <div className="text-lg font-bold mb-2">1 Package</div>
            <div className="text-gray-600">Full Price</div>
          </div>
          <div className="bg-white p-4 rounded-lg shadow">
            <div className="text-lg font-bold mb-2">2 Packages</div>
            <div className="text-green-600">5% Off Total</div>
          </div>
          <div className="bg-white p-4 rounded-lg shadow">
            <div className="text-lg font-bold mb-2">3 Packages</div>
            <div className="text-green-600">10% Off Total</div>
          </div>
          <div className="bg-white p-4 rounded-lg shadow">
            <div className="text-lg font-bold mb-2">4+ Packages</div>
            <div className="text-green-600">15%+ Off Total</div>
          </div>
        </div>
        <p className="mt-3 text-sm text-blue-600">Additional 5% discount for each package beyond the first. Mix and match any packages to maximize your savings!</p>
      </div>

      <div className="grid gap-6">
        {packages.map((pkg) => (
          <Card key={pkg.name} className="overflow-hidden">
            <div className="p-6">
              <div className="flex justify-between items-start mb-4">
                <div>
                  <h2 className="text-2xl font-bold mb-2">{pkg.name}</h2>
                  <p className="text-gray-600">{pkg.description}</p>
                </div>
                <div className="text-right">
                  <div className="mb-1">
                    <span className="font-semibold">Small (0-9,999 PNRs):</span> {pkg.pricing.small}
                  </div>
                  <div className="mb-1">
                    <span className="font-semibold">Medium (10,000-49,999 PNRs):</span> {pkg.pricing.medium}
                  </div>
                  <div>
                    <span className="font-semibold">Large (50,000+ PNRs):</span> {pkg.pricing.large}
                  </div>
                </div>
              </div>
              <button
                onClick={() => toggleAccordion(pkg.name)}
                className="text-blue-600 hover:text-blue-800 font-semibold flex items-center"
              >
                {openAccordions[pkg.name] ? 'Hide Details' : 'Show Details'}
                <svg
                  className={`ml-2 h-5 w-5 transform transition-transform ${
                    openAccordions[pkg.name] ? 'rotate-180' : ''
                  }`}
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M19 9l-7 7-7-7"
                  />
                </svg>
              </button>
              {openAccordions[pkg.name] && (
                <div className="mt-4 space-y-6">
                  {pkg.sections ? (
                    pkg.sections.map((section, index) => (
                      <div key={index} className="border-l-4 border-blue-500 pl-4">
                        <h3 className="text-lg font-bold text-blue-700 mb-3 flex items-center">
                          {section.title}
                        </h3>
                        <ul className="list-none space-y-2 ml-2">
                          {section.items.map((item, index) => (
                            <li key={index} className="text-gray-700 flex items-start">
                              <span className="text-blue-500 mr-2">•</span>
                              <span>{item}</span>
                            </li>
                          ))}
                        </ul>
                      </div>
                    ))
                  ) : (
                    <ul className="list-disc space-y-2 pl-4">
                      {pkg.bulletPoints.map((point, index) => (
                        <li key={index} className="text-gray-700">{point}</li>
                      ))}
                    </ul>
                  )}
                </div>
              )}
            </div>
          </Card>
        ))}
      </div>
    </div>
  );
};

export default PricingPackages;